var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgZipIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "41px",
  height: "51px",
  viewBox: "0 0 41 51",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "B7189F09-660D-4CF1-BD4B-C97382510D6E@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Schools/Web-SinglePlayer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Schools/Lessons/SinglePlayer",
  transform: "translate(-548.000000, -937.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lesson-plan",
  transform: "translate(355.500000, 872.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ZIP-icon",
  transform: "translate(193.000000, 66.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.2794067,0.75 L28.3294067,7.09085437 C28.3294067,8.62344455 28.9506116,10.0109446 29.9549641,11.015297 C30.9593166,12.0196495 32.3468166,12.6408544 33.8794067,12.6408544 L33.8794067,12.6408544 L39.2,12.6408544 L39.25,45.2 C39.25,46.3183766 38.7966883,47.3308766 38.0637825,48.0637825 C37.3308766,48.7966883 36.3183766,49.25 35.2,49.25 L35.2,49.25 L4.8,49.25 C3.68162338,49.25 2.66912338,48.7966883 1.93621754,48.0637825 C1.20331169,47.3308766 0.75,46.3183766 0.75,45.2 L0.75,45.2 L0.75,4.8 C0.75,3.68162338 1.20331169,2.66912338 1.93621754,1.93621754 C2.66912338,1.20331169 3.68162338,0.75 4.8,0.75 L4.8,0.75 L28.2794067,0.75 Z",
  id: "Rectangle",
  stroke: "#010b3b",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 28.4195679,
  y1: 0.66312513,
  x2: 39.3325012,
  y2: 12.5170231,
  id: "Path-2",
  stroke: "#010b3b",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9,23 C38.7836556,23 39.5,23.7163444 39.5,24.6 L39.5,33.4 C39.5,34.2836556 38.7836556,35 37.9,35 L2.1,35 C1.2163444,35 0.5,34.2836556 0.5,33.4 L0.5,24.6 C0.5,23.7163444 1.2163444,23 2.1,23 L37.9,23 Z M17.5728,25.0592 L12.4368,25.0592 L12.4368,26.0864 L15.9024,26.0864 L12.3312,31.1408 C12.2784,31.2176 12.2784,31.2176 12.2448,31.3064 C12.2224,31.3656 12.2224,31.3656 12.2149333,31.428 L12.2112,31.4912 L12.2112,32 L17.4912,32 L17.4912,30.968 L13.8864,30.968 L17.448,25.9376 C17.5416,25.8008 17.5416,25.8008 17.565,25.6424 L17.5728,25.5344 L17.5728,25.0592 Z M20.0208,25.0592 L18.7248,25.0592 L18.7248,32 L20.0208,32 L20.0208,25.0592 Z M23.9472,25.0592 L21.6912,25.0592 L21.6912,32 L22.9824,32 L22.9824,29.5568 L23.9472,29.5568 C24.624,29.5568 24.624,29.5568 25.1304,29.3888 C25.6368,29.2208 25.6368,29.2208 25.9728,28.9184 C26.3088,28.616 26.3088,28.616 26.4768,28.196 C26.6448,27.776 26.6448,27.776 26.6448,27.272 C26.6448,26.7872 26.6448,26.7872 26.484,26.3792 C26.3232,25.9712 26.3232,25.9712 25.992,25.6784 C25.6608,25.3856 25.6608,25.3856 25.152,25.2224 C24.74496,25.09184 24.74496,25.09184 24.218112,25.065728 L23.9472,25.0592 Z M23.9472,26.0576 C24.3072,26.0576 24.3072,26.0576 24.5712,26.1416 C24.8352,26.2256 24.8352,26.2256 25.008,26.384 C25.1808,26.5424 25.1808,26.5424 25.2672,26.768 C25.3536,26.9936 25.3536,26.9936 25.3536,27.272 C25.3536,27.5648 25.3536,27.5648 25.2672,27.8024 C25.1808,28.04 25.1808,28.04 25.0056,28.2056 C24.8304,28.3712 24.8304,28.3712 24.5664,28.46 C24.3024,28.5488 24.3024,28.5488 23.9472,28.5488 L22.9824,28.5488 L22.9824,26.0576 L23.9472,26.0576 Z",
  id: "Combined-Shape",
  fill: "#010b3b"
})))))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgZipIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zip-icon.3e768d689717078aa818d1f0e4afbd96.svg";